var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 7.68L19.91 7.59C19.8657 7.47968 19.7974 7.38061 19.71 7.3L14.71 2.3C14.6229 2.21571 14.5213 2.14794 14.41 2.1L14.32 2.07C14.2331 2.03962 14.142 2.02276 14.05 2.02C14.03 2.02 14.01 2.01 14 2.01H6C4.9 2.01 4 2.91 4 4.01V20.01C4 21.11 4.9 22.01 6 22.01H18C19.1 22.01 20 21.11 20 20.01V8.01C20 8.01 19.99 7.97 19.99 7.95C19.99 7.86 19.97 7.78 19.94 7.69V7.68ZM6 20V4H13V8C13 8.55 13.45 9 14 9H18V20H6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H10V18H8V12ZM11 10H13V18H11V10ZM14 14H16V18H14V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.2c5e126173cb82419f501aff675a53ca.svg";
export { ForwardRef as ReactComponent };